export const checkSchema = (item: any) => {
    if (item.schema && item.schema.properties && (Object.keys(item.schema).length !== 0 && Object.keys(item.schema.properties).length !== 0)) {
        return true;
    }
    return false;
}

export const isActionVisible = (item: any) => {
    if (item.schema?.is_executable === true) {
        return true;
    }
    return checkSchema(item);
}
